export default __webpack_public_path__ + "static/media/error-boundary.ea9a7610.svg";